import React, { useMemo, useCallback } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import * as chatActions from 'modules/chat';


import ChatItem from './ChatItem';

const ChatList = ({ refOuter, chatList, isLoading, defaultRowSize }) => {
  const dispatch = useDispatch();

  const chatLastPage = useSelector(state => state.chat.db.isLastPage);
  const activeChannel = useSelector(state => state.chat.activeChannel);
  

  const handleClickMore = useCallback(() => {
    if (isLoading || chatLastPage) {
      return;
    }
    dispatch(chatActions.loadMoreChat({room_id: activeChannel.room_id || ''}));
  },[dispatch, isLoading, chatLastPage, activeChannel.room_id]);

  const domList = useMemo(()=>{
    return (
      chatList.map(chat => (
        <ChatItem key={chat.key} data={chat}  />
      ))
    )
  },[chatList]);


  const domLoading = useMemo(()=>{
    if (chatLastPage) {
      return null;
    }
    return (
      <div className="btnArea">
        <button type="button" className={`more${isLoading ? ' loading' : ''}`} onClick={handleClickMore}>더 보기</button>
      </div>
    )
  },[isLoading, handleClickMore, chatLastPage]);


  return (
    <div className="issue" ref={refOuter}>
      {domList}
      {domLoading}
    </div>
  )
}

export default ChatList;